import { Typography, Icon, DateTimePicker } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { ReviewSection } from '@hero/molecules';

import * as S from './style';

export function GiftSetupSection({
  expirationDate,
  isCompleted = false,
  onDateSelect = () => {},
  stepIndex = 4
}) {
  const { t } = useTranslation();

  return (
    <ReviewSection
      stepIndex={stepIndex}
      isCompleted={isCompleted ?? !!expirationDate}
      title={t('giftSetup')}
      subTitle={t('giftSetupDescription')}
    >
      <S.GSOption>
        <S.GSOptionBody>
          <Typography variant="body1Bold">
            <Icon name="info" size="sm" />
            {t('redemptionDeadline')}
          </Typography>

          <DateTimePicker
            helperText={t('redemptionDeadlineDescription')}
            placeholder="Select a redemption deadline"
            value={expirationDate ? new Date(expirationDate) : null}
            onChange={onDateSelect}
            popperPlacement="bottom-start"
            showTimeSelect
            excludePast
            dateFormatWithTime="EEE, LLL d - hh:mm aa"
          />
        </S.GSOptionBody>
      </S.GSOption>
    </ReviewSection>
  );
}

GiftSetupSection.propTypes = {
  expirationDate: PropTypes.string,
  isCompleted: PropTypes.bool,
  onDateSelect: PropTypes.func,
  stepIndex: PropTypes.number
};
